import React, {useContext} from "react";
import styles from './ProjectMainInfo.module.scss';
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import {formatPercents} from "../../../../formatters";
import {isProjectLoan} from "../../../../utils/pages";

const ArrowRight = () => (
  <svg className={styles.projectMainInfo__arrowSvg} width="96" height="10" viewBox="0 0 96 10"
    fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5H90" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M85 1L91 5L85 9" stroke="currentColor" strokeWidth="1.2" fill="none"/>
  </svg>
);

const ArrowLeft = () => (
  <svg className={styles.projectMainInfo__arrowSvg} width="96" height="10" viewBox="0 0 96 10"
    fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M96 5H6" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M11 1L5 5L11 9" stroke="currentColor" strokeWidth="1.2" fill="none"/>
  </svg>
);

const SCHEME_LABELS = {
  factoring: {
    debtorRole: "дебитор",
    serviceLabel: "услуга",
    obligationLabel: "обязательство оплаты",
  },
  project: {
    debtorRole: "контрагент",
    serviceLabel: "приобретение требований",
    obligationLabel: "взыскание",
  },
};

const EMPTY_VALUE = "—";

const ProjectMainInfo = () => {
  const project = useContext(DetailedProjectContext).project;
  const cardInfo = project.cardInfo;

  const isProject = isProjectLoan(project);
  const schemeLabels = isProject ? SCHEME_LABELS.project : SCHEME_LABELS.factoring;
  const statsClassName = isProject
    ? `${styles.projectMainInfo__stats} ${styles["projectMainInfo__stats--project"]}`
    : styles.projectMainInfo__stats;

  return (
    <div className={styles.projectMainInfo}>
      <div className={styles.projectMainInfo__about}>
        <div className={styles.projectMainInfo__aboutLabel}>Главное о проекте</div>
        <p className={styles.projectMainInfo__aboutText}>{cardInfo?.mainAbout || EMPTY_VALUE}</p>
      </div>

      <div className={styles.projectMainInfo__scheme}>
        <div className={styles.projectMainInfo__party}>
          <div className={styles.projectMainInfo__partyName}>
            {project.company.name || EMPTY_VALUE}
          </div>
          <div className={styles.projectMainInfo__partyRole}>заемщик</div>
        </div>
        <div className={styles.projectMainInfo__arrows}>
          <div className={styles.projectMainInfo__arrowLabel}>{schemeLabels.serviceLabel}</div>
          <ArrowRight/>
          <ArrowLeft/>
          <div className={styles.projectMainInfo__arrowLabel}>{schemeLabels.obligationLabel}</div>
        </div>
        <div className={styles.projectMainInfo__party}>
          <div className={styles.projectMainInfo__partyName}>
            {cardInfo?.debtorName || EMPTY_VALUE}
          </div>
          <div className={styles.projectMainInfo__partyRole}>{schemeLabels.debtorRole}</div>
        </div>
      </div>

      <div className={statsClassName}>
        <div className={styles.projectMainInfo__stat}>
          <div className={styles.projectMainInfo__statLabel}>Тип займа</div>
          <div className={styles.projectMainInfo__statValue}>
            {cardInfo?.loanTypeText || EMPTY_VALUE}
          </div>
        </div>
        <div className={styles.projectMainInfo__stat}>
          <div className={styles.projectMainInfo__statLabel}>Цель займа</div>
          <div className={styles.projectMainInfo__statValue}>
            {cardInfo?.loanPurposeText || EMPTY_VALUE}
          </div>
        </div>
        {!isProject && (
          <div className={styles.projectMainInfo__stat}>
            <div className={styles.projectMainInfo__statLabel}>
              Отношение суммы займа к обеспечению
            </div>
            <div className={styles.projectMainInfo__statRatio}>
              <span className={styles.projectMainInfo__statRatioLabel}>LTV</span>
              <span className={styles.projectMainInfo__statValue}>
                {project.accounting.ltv ? formatPercents(project.accounting.ltv) : EMPTY_VALUE}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectMainInfo;
